const studentData = [
  {
    name: "JYOTIPRAKASH PORE",
    refNo: "ISFC-1051",
    memNo: "245804",
  },
  {
    name: "KSHITIJ GUPTA",
    refNo: "ISFC-1051",
    memNo: "245805",
  },
  {
    name: "ROHIT KUMAR",
    refNo: "ISFC-1051",
    memNo: "245806",
  },
  {
    name: "SATHI MAHATA",
    refNo: "ISFC-1051",
    memNo: "245807",
  },
  {
    name: "SAUMYADEEP CHAKRABARTY",
    refNo: "ISFC-1051",
    memNo: "245804",
  },
  {
    name: "TINA MUKHOPADHYAY",
    refNo: "ISFC-1051",
    memNo: "245809",
  },
  {
    name: "PRATYUSH KUMAR SINGH",
    refNo: "ISFC-1051",
    memNo: "245810",
  },
  {
    name: "PANKAJ KUMAR",
    refNo: "ISFC-1051",
    memNo: "245811",
  },
  {
    name: "ADITYA KUMAR SEN",
    refNo: "ISFC-1051",
    memNo: "245814",
  },
  {
    name: "SOYEB SARKAR",
    refNo: "ISFC-1051",
    memNo: "245815",
  },
  {
    name: "MD AZHARUDDIN",
    refNo: "ISFC-1051",
    memNo: "245816",
  },
  {
    name: "SHAHIN RIZWANA",
    refNo: "ISFC-1051",
    memNo: "245817",
  },
  {
    name: "AMAN KUMAR",
    refNo: "ISFC-1051",
    memNo: "245818",
  },
  {
    name: "ANKUSH CHAKRABORTY",
    refNo: "ISFC-1051",
    memNo: "245819",
  },
  {
    name: "SOUMADEEP SARKAR",
    refNo: "ISFC-1051",
    memNo: "245820",
  },
  {
    name: "SAHIL HOSSAIN",
    refNo: "ISFC-1051",
    memNo: "245821",
  },
  {
    name: "PARIJAT DAS",
    refNo: "ISFC-1051",
    memNo: "245822",
  },
  {
    name: "SAYAN DAS",
    refNo: "ISFC-1051",
    memNo: "245823",
  },
  {
    name: "RACHANA KUMARI",
    refNo: "ISFC-1051",
    memNo: "245824",
  },
  {
    name: "SUBHAM SAHA",
    refNo: "ISFC-1051",
    memNo: "245825",
  },
  {
    name: "SOMRIK KAR",
    refNo: "ISFC-1051",
    memNo: "245826",
  },
  {
    name: "AASTIK DAS GUPTA",
    refNo: "ISFC-1051",
    memNo: "245829",
  },
  {
    name: "AASHISH GAUTAM",
    refNo: "ISFC-1051",
    memNo: "245830",
  },
  {
    name: "SAYAN ADAK",
    refNo: "ISFC-1051",
    memNo: "245812",
  },
  {
    name: "AVIK PANDA",
    refNo: "ISFC-1051",
    memNo: "245813",
  },
  {
    name: "SOURAV PRAMANIK",
    refNo: "ISFC-1051",
    memNo: "245827",
  },
  {
    name: "NASHIMUDDIN MOLLAH",
    refNo: "ISFC-1051",
    memNo: "245828",
  },
];

export default studentData;
